export default __webpack_public_path__ + "beta-maps-guides-3d-terrain-1200-ef4d83149c34f84375c8f50db44279ba.png";